package com.milta.feature.auth.domain.entity

/** Result of calling `AuthApi.authenticateWithOAuth` right after obtaining the provider ID token. */
sealed interface OAuthAuthenticateOutcome {
    /** No account is linked to this OAuth identity yet — client falls back to registration. */
    data object NotRegistered : OAuthAuthenticateOutcome

    /** Account exists but its phone was never verified — an OTP was just sent to [phoneNumber]. */
    data class PhoneVerificationRequired(val phoneNumber: String) : OAuthAuthenticateOutcome

    /** Account exists and its phone is already verified — fully authenticated, tokens saved. */
    data class Authenticated(val role: String) : OAuthAuthenticateOutcome
}
